import { createAsyncThunk } from '@reduxjs/toolkit'

import i18n from '../../../i18n'
import { AIMarketInsightsService } from '../api/AIMarketInsightsService'
import {
  FetchNewsParams,
  NewsPeriodAiAnalysis,
  NewsPeriodAnalysisTypeEnum,
  NewsSymbol,
} from '../api/types'

// ---------------------------------------------------------------------

export const SLICE_NAME = 'aiMarketInsights'

export const GetNews = createAsyncThunk(
  `${SLICE_NAME}/GetNews`,
  async (params: FetchNewsParams, thunkAPI) => {
    const language = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]
    const { data, success } = await AIMarketInsightsService.getNews({ ...params, language })

    if (success) return data

    return thunkAPI.rejectWithValue(null)
  },
)

export const GetSymbols = createAsyncThunk(`${SLICE_NAME}/GetSymbols`, async (_, thunkAPI) => {
  const { data, success } = await AIMarketInsightsService.getSymbolsWithNews()

  if (success) return data as NewsSymbol[]

  return thunkAPI.rejectWithValue(null)
})

export const GetDailyAnalysis = createAsyncThunk(
  `${SLICE_NAME}/GetDailyAnalysis`,
  async (_, thunkAPI) => {
    const language = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]
    const { data, success } = await AIMarketInsightsService.getLastNewsPeriodAiAnalysis({
      period: NewsPeriodAnalysisTypeEnum.DAILY,
      language,
    })

    if (success) return data as NewsPeriodAiAnalysis[]

    return thunkAPI.rejectWithValue(null)
  },
)

export const GetLast7DaysAnalysis = createAsyncThunk(
  `${SLICE_NAME}/GetLast7DaysAnalysis`,
  async (_, thunkAPI) => {
    const language = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]
    const { data, success } = await AIMarketInsightsService.getLastNewsPeriodAiAnalysis({
      period: NewsPeriodAnalysisTypeEnum.LAST7DAYS,
      language,
    })

    if (success) return data as NewsPeriodAiAnalysis[]

    return thunkAPI.rejectWithValue(null)
  },
)
